import jwtAxios from '@tenant/services/auth/jwt-auth';

// Wave 1 (developer-portal-auditing-framework) read/query surface — GET-only
// (AuditController.cs: [Route("api/audit-log")], [HttpGet]). Portion A (this slice) is an
// internal reader over that endpoint; the query params mirror AuditQuery.cs exactly
// (EntityType, EntityId, ActorUserId, SystemActorOnly, OccurredFrom, OccurredTo,
// CorrelationId, AppId, Page, PageSize). Response is AuditQueryResult.cs
// (Items/TotalCount/Page/PageSize/WindowClamped), PascalCase.
export const AUDIT_LOG_APIS = {
  ROOT: 'api/audit-log',
};

export const getAuditLogQuery = (params) => {
  return jwtAxios.get(AUDIT_LOG_APIS.ROOT, { params });
};
